import { render, staticRenderFns } from "./SharediFrameView.vue?vue&type=template&id=f71118b8&scoped=true&"
import script from "./SharediFrameView.vue?vue&type=script&lang=js&"
export * from "./SharediFrameView.vue?vue&type=script&lang=js&"
import style0 from "./SharediFrameView.vue?vue&type=style&index=0&id=f71118b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71118b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
